import { render, staticRenderFns } from "./monitoring4Populate.vue?vue&type=template&id=87317c32"
import script from "./monitoring4Populate.vue?vue&type=script&lang=js"
export * from "./monitoring4Populate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports